import React from 'react';
import { bool, number, shape, string } from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { imageUrl } from 'util/images';

function SponsoredHeaderImage({ header, isAmp }) {
  if (isAmp) {
    return (
      <a href={header.url} aria-label={header.alt}>
        <amp-img
          media="(min-width: 768px)"
          src={imageUrl(header.imageUrl, { width: 450 })}
          alt={header.alt}
          width={header.width}
          height={header.height}
        />
        <amp-img
          media="(max-width: 768px)"
          src={imageUrl(header.imageUrl, { width: 320 })}
          alt={header.alt}
          width={header.width * 0.7}
          height={header.height * 0.7}
        />
      </a>
    );
  }
  return (
    <Link href={header.url}>
      <a aria-label={header.alt}>
        <Image
          url={header.imageUrl}
          maxSize={{
            width: 400
          }}
          sourceSizes={[
            {
              layoutWidth: {
                value: 400,
                units: `px`
              }
            }
          ]}
          alt={header.alt || ''}
        />
      </a>
    </Link>
  );
}

SponsoredHeaderImage.propTypes = {
  header: shape({
    url: string,
    imageUrl: string,
    alt: string,
    width: number,
    height: number
  }).isRequired,
  isAmp: bool.isRequired
};

export default SponsoredHeaderImage;
